import { requestPlatform } from '@/plugins/axios'

// {machine}  更改机台的属性
export function onSubmit(data) {
   return requestPlatform({
        url: '/machine/update',
        method: 'POST',
        data: data
      })
}
